
import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';
import { StageItemMergeData } from './stage.items.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Code,
    name: 'JobItemMergeDataSchema',
})
export class JobItemMergeData extends StageItemMergeData {

    @MergeField()
    technician: string;

    @MergeField()
    stageNumber: string;

    @MergeField()
    stageName: string;
}

export const JobItemMergeDataSchema = getSchema(JobItemMergeData);

